// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesCtf = {
  ctfAuth: "CTF 認証",
  ctfDependency: "CTF 依存先",
  ctfRuntime: "CTF ランタイム",
  ctfBusinessEvent: "CTF 業務イベント",
} as const;
